import { alpha } from "@commonlibs";
import styled, { css } from "styled-components";
import ButtonWithIcon from "../ButtonWithIcon/ButtonWithIcon";

export const DeleteButtonRoot = styled(ButtonWithIcon)(
    ({ theme }) => css`
        &.delete-button {
            && {
                border-color: ${theme.palette.status.error};
                color: ${theme.palette.status.error};
                &:not(.Disabled) {
                    &:hover {
                        background-color: ${alpha(theme.palette.red, 0.09)};
                    }
                }

                &:active {
                    background-color: ${alpha(theme.palette.red, 0.16)};
                }
            }
        }
    `,
);
